import _ from 'lodash';

import {safeGet, safeSet, safeRemove} from 'ub/utils';
import pomUpdates from 'ub_legacy/lp/pom/updates/updates';

// This upgrader adds `geometry.layoutAxis` to form elements.
// The default value is "vertical", representing the old, full-width, vertical form layout.

const checkVersion = (pomData, minVersion, newVersion) => {
  const current = pomData.version || '0';

  if (current >= newVersion) {
    return false;
  }

  if (current < minVersion) {
    throw new Error(`Page version ${current} can't be updated to version ${newVersion}`);
  }
  return true;
};

pomUpdates.add({
  minVersion: '2.7',
  version: '2.8',

  run: function(pomData0) {
    if (!checkVersion(pomData0.mainPage, this.minVersion, this.version)) {
      return pomData0;
    }

    const pomData = _.cloneDeep(pomData0);
    const DEFAULT_FIELD_WIDTH = 200;

    const updateElement = (el) => {
      if (el.type === 'lp-pom-form') {
        if (!safeGet(el, 'geometry.layoutAxis')) {
          safeSet(el, 'geometry.layoutAxis', 'vertical');
        }

        if (!safeGet(el, 'geometry.field.width')) {
          safeSet(el, 'geometry.field.width', DEFAULT_FIELD_WIDTH);
        }

        if (safeGet(el, 'geometry.label.height')) {
          safeRemove(el, 'geometry.label.height');
        }
      }
    };

    [pomData.mainPage, ...pomData.subPages].forEach((page) => {
      page.elements.forEach(updateElement);
      page.version = this.version;
    });

    return pomData;
  }
});



// WEBPACK FOOTER //
// ./src/updaters/2.8.js